import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Icons, WhetherIconTitle, WhetherIconsWithAnimations } from "../../../Constants/Constants";
import { weatherIconData } from "../../../Data/Icons/WhetherIcon";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const WhetherIconContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={WhetherIconTitle} parent={Icons} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={WhetherIconsWithAnimations} />
              <CardBody>
                <Row className="icon-lists whether-icon">
                  {weatherIconData.map((icon, i) => (
                    <Col lg="2" xs="3" key={i}>
                      {icon.icon}
                    </Col>
                  ))}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default WhetherIconContainer;
